module.exports = __webpack_public_path__ + "files/a3a94aacdff1bef77ab4962664a6b42d.png";